export default "__VITE_ASSET__82e767dd__"